import PostsLoader from "./Loader";
import PostsList from "./PostsList";
import type { TGenericPostsProps } from "./typings";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import cls from "./styles.module.css";
import { Suspense } from "react";
import { useScrollRestoration } from "@/hooks/use-scroll-restoration";
import QueryErrorBoundary from "@/components/ErrorBoundary/QueryErrorBoundary";
import Loading from "./loading";

function PostsFeed(props: TGenericPostsProps) {
  const { data, isFetching, fetchNextPage, hasNextPage } =
    useSuspenseInfiniteQuery({
      queryKey: props.queryKey,
      queryFn: props.loader,
      getNextPageParam: (lastPage) => lastPage?.endCursor,
      initialPageParam: undefined,
      refetchOnWindowFocus: false,
    });
  return (
    <>
      <PostsList pages={data.pages} />
      <PostsLoader
        hasMore={hasNextPage}
        fetchMore={fetchNextPage}
        isFetching={isFetching}
      />
    </>
  );
}
export default function PostsFeedWithSuspense(props: TGenericPostsProps) {
  useScrollRestoration(JSON.stringify(props.queryKey));
  return (
    <main className={cls.root}>
      <QueryErrorBoundary>
        <Suspense fallback={<Loading />}>
          <PostsFeed {...props} />
        </Suspense>
      </QueryErrorBoundary>
    </main>
  );
}
